
















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import version from "@/version";

@Component({
    ...mapGetters(["accountBook"])
})
export default class InventoryBalanceSheet extends Vue {
    @Prop({ type: String })
    startPeriod?: string;

    @Prop({ type: String })
    endPeriod?: string;

    @Prop({ type: Boolean,default:true })
    isRetract?: boolean;

    @Prop({ type: Array })
    tableData?: Balance.Balance;

    startTime: string = "";
    endTime: string = "";
    isShowTr(isLeaf:any) {
        if (this.isRetract) return true
        else {
            if(isLeaf === 0) return true
            else return false
        }
    }
    created() {
        if (this.startPeriod) {
            this.startTime =
                this.startPeriod.substring(0, 4) +
                "年" +
                this.startPeriod.substring(4, 6) +
                "月";
        }
        if (this.endPeriod) {
            this.endTime =
                this.endPeriod.substring(0, 4) +
                "年" +
                this.endPeriod.substring(4, 6) +
                "月";
        }
    }

    downloadExcel() {
        let url = `${Vue.axios.defaults.baseURL}export/balance/dim/num?accountBookId=${this.$store.state.accountBook.id}&dimAccountType=存货&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&token=${this.$store.state.account.token}&version=${version}&showSub=${this.isRetract}`;
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", url);
    }
}
